import { UiTheme } from '../../theme'

export default (theme: UiTheme) => ({
  link: {
    base: {
      display: 'inline-block',
      ...theme.typography.body,
      fontWeight: theme.settings.typography.weights.semibold,

      '.intent-mouse &:focus': {
        outline: 'none',
      },

      '@media print': {
        fontSize: 'inherit',
      },
    },
    hoverable: {
      cursor: 'pointer',
    },

    variants: {
      regular: {
        color: theme.colors.text.normal,
        ':hover': {
          color: 'black',
        },
      },
      light: {
        color: theme.colors.text.light,
        ':hover': {
          color: theme.colors.text.lightHover,
        },
        ':active': {
          color: theme.colors.text.lightActive,
        },
      },
      primary: {
        color: theme.colors.accents.primary,
        ':hover': {
          color: theme.colors.accents.primaryHover,
        },
        ':active': {
          color: theme.colors.accents.primaryActive,
        },
        textDecoration: 'none',
      },
      positive: {
        color: theme.colors.accents.positive,
        ':hover': {
          color: theme.colors.accents.positiveHover,
        },
        ':active': {
          color: theme.colors.accents.positiveActive,
        },
        textDecoration: 'none',
      },
      secondary: {
        color: theme.colors.accents.secondary,
        ':hover': {
          color: theme.colors.accents.secondaryHover,
        },
        ':active': {
          color: theme.colors.accents.secondaryActive,
        },
        textDecoration: 'none',
      },
      negative: {
        color: theme.colors.accents.negative,
        ':hover': {
          color: theme.colors.accents.negativeHover,
        },
        ':active': {
          color: theme.colors.accents.negativeActive,
        },
        textDecoration: 'none',
      },
    },

    block: {
      display: 'block',
      textDecoration: 'none',
    },

    underline: {
      textDecoration: 'underline',
    },
  },
  downloadIcon: {
    marginLeft: '2px',
    position: 'relative',
    top: '2px',
  },
  externalLinkIcon: {
    marginLeft: '4px',
    position: 'relative',
    top: '1px',
  },
})
